import { Component } from '@angular/core';

@Component({
  selector: 'app-full-screen-layout',
  template: `<router-outlet/>`,
  standalone: false,
})
export class FullScreenLayoutComponent {

}
